import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import * as $ from 'jquery';

import { SharedService } from "./../../shared/shared.service";


@Component({
  selector: 'devotee-home',
  templateUrl: './devotee-home.component.html',
  styleUrls: ['./devotee-home.component.css']
})
export class DevoteeHomeComponent implements OnInit {

  constructor(private router: Router,
    private sharedService: SharedService) { }

  ngOnInit() {
    this.jqueryFunction();
    let devoteData = this.sharedService.getDevoteeDataAtLocStorage();
    if (devoteData == null && !this.isWithOutLoginUrl()) {
      this.router.navigate(["/login"]);
    }

    console.log(this.router.url)
  }

  logout(): void {
    this.sharedService.removeDevoteeDataAtLocStorage();
    this.sharedService.removeTokenDataAtLocStorage();
    this.router.navigate(["login"]);
  }

  jqueryFunction() {
    $(document).ready(function () {
      var navMain = $(".navbar-collapse");

      navMain.on("click", "a:not([data-toggle])", null, function () {
        navMain.removeClass('in');
      });
    });
  }

  isWithOutLoginUrl(): boolean {
    const url = window.location.href;
  
    return url.indexOf('serialkey') > 0 ||
           url.indexOf('about-us') > 0 ||
           url.indexOf('contact-us') > 0 ||
           url.indexOf('privacy-policy') > 0 ||
           url.indexOf('termsconditions') > 0 ||
           url.indexOf('shipping-policy') > 0 ||
           url.indexOf('mobileapp') > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee-home/devotee-home.component.ts